/**
 * Logo — SSOT for the Chiefy brand mark.
 *
 * Extracted from Sidebar so any surface that needs the brand can drop
 * in `<Logo />` instead of re-importing the static images and styling
 * the wrapper. Used by Sidebar (icon-only / icon+wordmark depending on
 * collapsed state) and by SplashScreen (large + wordmark).
 */

import logo from '../../assets/images/logo.png';
import logoText from '../../assets/images/logo-text.png';
import './Logo.css';

export type LogoSize = 'xs' | 'sm' | 'md' | 'lg';

export type LogoProps = {
    /** Icon dimensions: xs=24, sm=32, md=40, lg=56 px. Default 'md'. */
    size?: LogoSize;
    /** Render the "CHIEFY" wordmark next to the icon. Default false. */
    wordmark?: boolean;
    /** Wrap in an `<a href="/">` so clicking returns to the app root.
     *  Default false. */
    asLink?: boolean;
    /** Accessible label. Defaults to "Chiefy" (icon-only) or "Chiefy
     *  home" (when `asLink`). */
    ariaLabel?: string;
    className?: string;
};

function Logo({
    size = 'md',
    wordmark = false,
    asLink = false,
    ariaLabel,
    className = '',
}: LogoProps) {
    const inner = (
        <>
            <img src={logo} alt="" className={`ui-logo__icon ui-logo__icon--${size}`} />
            {wordmark && (
                <img src={logoText} alt="" className={`ui-logo__wordmark ui-logo__wordmark--${size}`} />
            )}
        </>
    );

    const wrapperClass = `ui-logo ${className}`.trim();

    if (asLink) {
        return (
            <a
                href="/"
                className={wrapperClass}
                aria-label={ariaLabel ?? 'Chiefy home'}
            >
                {inner}
            </a>
        );
    }
    return (
        <span className={wrapperClass} role="img" aria-label={ariaLabel ?? 'Chiefy'}>
            {inner}
        </span>
    );
}

export default Logo;
